import React from 'react';
import PropTypes from 'prop-types';
import { TableCell, TableHead, TableRow } from '@material-ui/core';

const ApplicationTableHeader = ({ leftAction, rightActionLabel, categoriesEnabled, subcategoriesEnabled }) => (
  <TableHead>
    <TableRow>
      {leftAction && <TableCell padding="none" />}
      <TableCell padding="none">Numer</TableCell>
      <TableCell padding="none">Nazwa projektu</TableCell>
      {categoriesEnabled && <TableCell padding="none">Kategoria</TableCell>}
      {subcategoriesEnabled && <TableCell padding="none">Podkategoria</TableCell>}
      <TableCell align="right" padding="none">Koszt</TableCell>
      {rightActionLabel && <TableCell align="right" padding="none">{rightActionLabel}</TableCell>}
    </TableRow>
  </TableHead>
);

ApplicationTableHeader.propTypes = {
  leftAction: PropTypes.bool,
  rightActionLabel: PropTypes.string,
  categoriesEnabled: PropTypes.bool,
  subcategoriesEnabled: PropTypes.bool,
};

export default ApplicationTableHeader;


// WEBPACK FOOTER //
// ./src/components/budget/types/ApplicationTableHeader.js